/**
 * Colores del sistema de diseño PEICAR que usa "Ajustes del bot" (diseño v3).
 * Van en un solo lugar para no repetir hex sueltos en cada componente.
 */
export const C = {
  ink: '#0F172A',
  ink2: '#475569',
  ink3: '#64748B',
  gris: '#77787B',
  grisClaro: '#A7A9AC',
  linea: '#E7E7E7',
  lineaSuave: '#F3F4F6',
  fondo: '#F8FAFC',
  steel: '#21588C',
  cyan: '#32B8DF',
  cyanBorde: '#34C6F1',
  cyanTinte: 'rgba(52,198,241,0.08)',
  menta: '#22EC9A',
  verde: '#00BA6E',
  mentaBurbuja: 'rgba(34,236,154,0.16)',
  naranja: '#FF6C0E',
  naranjaTexto: '#C2410C',
  naranjaFondo: '#FFF6E5',
  apagado: '#CECECE',
  navy: '#0C2036',
};

export const pista = (on) => (on ? C.menta : C.apagado);

export const chip = (color, borde) => ({
  fontSize: 11, color, border: `1px solid ${borde}`, borderRadius: 10,
  padding: '0 7px', display: 'inline-flex', gap: 4, alignItems: 'center', lineHeight: '18px',
  whiteSpace: 'nowrap',
});

export const MONO = "'JetBrains Mono', ui-monospace, SFMono-Regular, Menlo, monospace";
